"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCoreFollowedIdMapSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const state_1 = require("./state.js");
exports.removeCoreFollowedIdMapSlice = (0, xuder_1.createRemoveSyncSlice)({
    name: name_1.CoreFollowedIdMapName,
    state: state_1.defaultFollowedIdMapState,
    transform: (action, state = {}) => {
        if (!action.length) {
            return state;
        }
        for (const entry of action) {
            delete state[entry];
        }
        return state;
    }
});
//# sourceMappingURL=remove.js.map